import React, { Component } from 'react';
import { connect } from 'react-redux';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import { Button } from 'reactstrap';

import './WhatsNext.scss';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Confirmation',
      event: 'Credit Card Step 8'
  }
}

class WhatsNext extends Component {
  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs)
  }

  render() {   
    return (
      <div className="whats-next">
        <p className="application-id">Visa Application Id: {this.props.application.visaApplicationId}</p>
        <h1>We’ve received your application.</h1>                
        <div className={"card-image "+this.props.card.type}></div>
        <p>Thanks for choosing Vancity. Here’s what you can expect to happen next:</p>
        <ol>
          <li><span><b>You’ll receive a decision</b> on your application within 7 to 10 business days.</span></li>
          <li><span>If you’re approved, <b>you’ll receive two pieces of mail</b> from us. One letter will contain your PIN # and the other will contain the card itself along with a copy of the Cardholder Agreement.</span></li>
          <li><span>You’ll then need to <b>activate your card</b>.</span></li>
        </ol>

        <div className="buttons-container">
          <Button color="primary" size="lg" href="https://www.vancity.com">Go to vancity.com</Button>          
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  application: state.application,
  card: state.card
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("whats-next")(WhatsNext));


// WEBPACK FOOTER //
// ./src/containers/WhatsNext/WhatsNext.js